import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function FAQSection() {
  const {
    formattedTime
  } = useCountdown();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const checkoutUrl = 'http://checkout.sabores365.online/cart/59172040638545:1';
  const faqs = [{
    q: '¿Qué formato tiene la guía?',
    a: 'La guía está en formato digital (PDF). Podés descargarla inmediatamente después de tu compra y leerla desde cualquier dispositivo.'
  }, {
    q: '¿Cuánto tiempo tarda en llegar?',
    a: 'El acceso es inmediato. Una vez que completes tu compra, vas a recibir el link de descarga al instante.'
  }, {
    q: '¿Funciona para cualquier edad?',
    a: 'Sí. La guía está diseñada para mujeres de todas las edades que quieran entender y mejorar su equilibrio hormonal de forma natural.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 45 días de garantía total. Si no estás satisfecha, te devolvemos el dinero sin preguntas.'
  }, {
    q: '¿Necesito conocimientos previos?',
    a: 'No. Todo está explicado de forma simple y práctica para que cualquier persona pueda aplicarlo.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Podés leer la guía desde tu celular, tablet o computadora.'
  }];
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <h2 className="text-3xl font-bold text-center mb-10" data-id="element-44">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-45">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-brand-green/10 overflow-hidden" data-id="element-46">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-47">
                <span className="font-bold text-gray-800" data-id="element-48">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-green transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-50">
                <p className="text-gray-600" data-id="element-51">{faq.a}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-52">
          <p className="text-lg font-medium mb-4" data-id="element-53">
            Ahora también podés empezar vos.
          </p>
          <a href={checkoutUrl} className="inline-block w-full md:w-auto bg-brand-gold hover:bg-yellow-500 text-brand-green font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(212,168,67,0.4)] hover:shadow-[0_12px_25px_rgba(212,168,67,0.6)] transform hover:-translate-y-1 transition-all duration-300 mb-4" data-id="element-54">
            ÚLTIMA OPORTUNIDAD - OBTENER MI GUÍA
          </a>
          <p className="text-brand-red font-bold" data-id="element-55">
            La oferta cierra en: {formattedTime}
          </p>
        </div>
      </div>
    </section>;
}